/*
  This file contains the actions for the user headers.
  USE ONLY INSIDE AXIOS RESPONSE INTECEPTOR
*/

export const TYPES = {
  SET_USER_HEADER_LAST_VERSION: "SET_USER_HEADER_LAST_VERSION",
  SET_CLOSET_HEADER_LAST_VERSION: "SET_CLOSET_HEADER_LAST_VERSION",
};

export function setUserHeaderLastVersion(userHeaderLastVersion) {
  return (dispatch) => {
    dispatch({
      type: TYPES.SET_USER_HEADER_LAST_VERSION,
      userHeaderLastVersion,
    });
  };
}

export function setClosetHeaderLastVersion(closetHeaderLastVersion) {
  return (dispatch) => {
    dispatch({
      type: TYPES.SET_CLOSET_HEADER_LAST_VERSION,
      closetHeaderLastVersion,
    });
  };
}
